import {
    createContext,
    Dispatch,
    PropsWithChildren,
    SetStateAction,
    useContext,
    useState
} from 'react';
import { SIDEBAR_NARROW_BREAKPOINT } from '../../config';

type State = {
    isNarrow: boolean;
    width: number;
};

type StateContext = {
    setState: Dispatch<SetStateAction<State>>;
} & State;

export const SidenavStateContext = createContext<StateContext>(null);

export const SidenavProvider = ({ children }: PropsWithChildren<{}>) => {
    const [state, setState] = useState<State>({
        isNarrow: localStorage.getItem('sideBarWidth')
            ? parseInt(localStorage.getItem('sideBarWidth')) >
              SIDEBAR_NARROW_BREAKPOINT
                ? false
                : true
            : false,
        width: parseInt(localStorage.getItem('sideBarWidth')) || 200
    });

    return (
        <SidenavStateContext.Provider value={{ ...state, setState }}>
            {children}
        </SidenavStateContext.Provider>
    );
};

export const useSidenavState = () => useContext(SidenavStateContext);
